import { useGetProductsInCard } from './useGetProductsInCard';
import { shuffle } from 'lodash';

export function useGetRecommendedProducts(nbProduct = 5) {
  const { products } = useGetProductsInCard();
  const productsRecommended = shuffle(products).slice(0, nbProduct);
  return { productsRecommended };
}
